var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemoveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "10px",
    viewBox: "0 0 8 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Remove") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Integration-and-Tutorials",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Integrations-2020",
    transform: "translate(-353.000000, -262.000000)",
    stroke: "#FF6565"
  }, /*#__PURE__*/React.createElement("g", {
    id: "THUMBNAIL",
    transform: "translate(214.000000, 174.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(139.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Remove",
    transform: "translate(0.000000, 68.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.72222222,1.55555556 L6.72222222,7 C6.72222222,7.42955481 6.37399925,7.77777778 5.94444444,7.77777778 L2.05555556,7.77777778 C1.62600075,7.77777778 1.27777778,7.42955481 1.27777778,7 L1.27777778,1.55555556 M5.55555556,1.55555556 L7.5,1.55555556 L1.27777778,1.55555556 L0.5,1.55555556 L2.44444444,1.55555556 L2.44444444,0.777777778 C2.44444444,0.348222972 2.79266742,0 3.22222222,0 L4.77777778,0 C5.20733258,0 5.55555556,0.348222972 5.55555556,0.777777778 L5.55555556,1.55555556 Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIcon);
export default __webpack_public_path__ + "static/media/remove-icon.d2b6745e0850fd29bd51a5cd7f962595.svg";
export { ForwardRef as ReactComponent };